import { type InputHTMLAttributes, type JSX, useState, type ClassAttributes } from 'react'
import { setState } from '../../services/switcherServices';
import { MENUITEMS, type Menuitemtype } from '../../layouts-components/sidebar/nav';


const switcherSelector = (selector: string) => {

	if (typeof selector !== 'string' || selector.trim() === '') {
		return null;
	}
	return document?.querySelector<HTMLElement>(selector);
};

const switcherDoucmentIdSelector = (selector: string): HTMLElement | null => {
	return document.getElementById(selector);
};

const getDocumentElement = (): HTMLElement => {
	return document.documentElement;
};

const getPreferredThemeMode = (): 'dark' | 'light' => {
	const storedTheme = localStorage.getItem('caresThemeMode');
	if (storedTheme === 'dark' || storedTheme === 'light') {
		return storedTheme;
	}

	if (localStorage.getItem('udondarkTheme')) {
		return 'dark';
	}

	if (localStorage.getItem('udonlightTheme')) {
		return 'light';
	}

	return window.matchMedia?.('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
};

export const updateTheme = (themeType: string, clicked: string | boolean) => {
	const normalizedTheme = themeType === "dark" ? "dark" : "light";
	const newState = {
		dataThemeMode: normalizedTheme,
		dataHeaderStyles: normalizedTheme,
		dataMenuStyles: normalizedTheme,
		bodyBg: "",
		bodyBg2: "",
		inputBorder: "",
		formControlBg: '',
		lightRgb: "",
		gray: ""
	}
	setState(newState)
	localStorage.setItem('caresThemeMode', normalizedTheme);
	localStorage.setItem(`udon${normalizedTheme}Theme`, normalizedTheme);
	localStorage.removeItem(`udon${normalizedTheme === "dark" ? "light" : "dark"}Theme`);

	if (clicked === 'clicked') {
		localStorage.removeItem("bodyBg");
		localStorage.removeItem("bodyBg2");
		localStorage.removeItem("bgImg");
		localStorage.removeItem("udonheader");
		localStorage.removeItem("udonmenu");
	}

};

export const setDirection = (direction: 'ltr' | 'rtl') => {
	const newState = {
		dir: direction
	};

	setState(newState);
	if (direction === 'rtl') {
		localStorage.setItem("udonrtl", 'rtl');
		localStorage.removeItem("udonltr");
	} else {
		localStorage.removeItem("udonrtl");
	}
};

export function closeMenu() {
	const closeMenudata = (items: Menuitemtype[]) => {
		items?.forEach((item) => {
			item.active = false;
			if (item.children) {
				closeMenudata(item.children);
			}
		});
	};
	closeMenudata(MENUITEMS);
}

export const updateLayout = (layoutType: string) => {
	setTimeout(() => {
		switcherSelector('')?.click();
	}, 100);

	const newState = {
		dataNavLayout: layoutType === "horizontal" ? "horizontal" : "vertical",
		dataVerticalStyle: layoutType === "vertical" ? "overlay" : "",
		dataNavStyle: localStorage.udonnavstyles ? localStorage.udonnavstyles : layoutType === "horizontal" ? "menu-click" : '',
		toggled: layoutType === "vertical" ? "" : undefined
	};

	setState(newState);
	localStorage.setItem('udonLayout', layoutType);

	if (layoutType === "vertical") {
		localStorage.removeItem('udonnavstyles');
	} else {
		localStorage.removeItem("udonverticalstyles");
	}

	const Sidebar: HTMLElement | null = switcherSelector('.main-menu');
	if (Sidebar) {
		Sidebar.style.marginInline = '0px';
	}

	closeMenu();

};

export const updateNavStyle = (actionType: string, toggledState: string) => {

	const newState = {
		dataNavStyle: actionType,
		toggled: toggledState,
		dataVerticalStyle: "",
	}

	setState(newState);
	localStorage.setItem('udonnavstyles', actionType);
	localStorage.removeItem('udonverticalstyles')

	if (actionType === "icon-click" || actionType === "icon-hover") {
		const Sidebar: HTMLElement | null = switcherSelector('.main-menu');
		if (Sidebar) {
			Sidebar.style.marginInline = '0px';
		}
	}
};

export const DefaultMenu = () => {
	const newState = {
		dataVerticalStyle: "overlay",
		dataNavLayout: "vertical",
		toggled: "",
		dataNavStyle: "",
	}
	setState(newState);
	localStorage.setItem('udonverticalstyles', 'default');
	localStorage.removeItem('udonverticalstyles');
	localStorage.removeItem('udonnavstyles');
};

export const ClosedMenu = () => {
	const newState = {
		dataNavLayout: "vertical",
		dataVerticalStyle: "closed",
		toggled: "close-menu-close",
	}
	setState(newState);
	localStorage.setItem('udonverticalstyles', 'closed');
};

export const IconTextOpenFn = () => {
	let html = getDocumentElement();
	if (html.getAttribute('data-toggled') === 'icon-text-close') {
		html.setAttribute('data-icon-text', 'open');
	}
}

export const IconTextCloseFn = () => {
	let html = getDocumentElement();
	if (html.getAttribute('data-toggled') === 'icon-text-close') {
		html.removeAttribute('data-icon-text');
	}
}

export const IconText = () => {
	const newState = {
		dataNavLayout: "vertical",
		dataVerticalStyle: "icontext",
		toggled: "icon-text-close",
		dataNavStyle: "",
	}
	setState(newState);
	localStorage.setItem('udonverticalstyles', 'icontext');
	const MainContent = switcherSelector('.main-content');
	const appSidebar = switcherSelector('.app-sidebar');

	appSidebar?.addEventListener('click', () => {
		IconTextOpenFn();
	});

	MainContent?.addEventListener('click', () => {
		IconTextCloseFn();
	});
};

export const iconOverlayFn = () => {
	const newState = {
		dataNavLayout: "vertical",
		dataVerticalStyle: "overlay",
		toggled: "icon-overlay-close",
		dataNavStyle: ''
	};
	setState(newState);
	localStorage.setItem('udonverticalstyles', 'overlay');
	const icon = switcherDoucmentIdSelector('switcher-icon-overlay') as HTMLInputElement;
	if (icon) {
		icon.checked = true;
	}

	const MainContent = switcherSelector('.main-content');
	const appSidebar = switcherSelector('.app-sidebar');


	if (appSidebar) {
		appSidebar.addEventListener("mouseenter", DetachedOpenFn);
		appSidebar.removeEventListener("mouseenter", DetachedOpenFn);
	}

	if (MainContent) {
		MainContent.addEventListener("mouseleave", DetachedCloseFn);
		MainContent.removeEventListener("mouseleave", DetachedCloseFn);
	}
};

function DetachedOpenFn() {
	let html = getDocumentElement();
	if (window.innerWidth > 992) {
		if (html.getAttribute('data-toggled') === 'detached-close' || html.getAttribute('data-toggled') === 'icon-overlay-close') {
			html.setAttribute('data-icon-overlay', 'open');
		}
	}
}

function DetachedCloseFn() {
	let html = getDocumentElement();
	if (window.innerWidth > 992) {
		if (html.getAttribute('data-toggled') === 'detached-close' || html.getAttribute('data-toggled') === 'icon-overlay-close') {
			html.removeAttribute('data-icon-overlay');
		}
	}
}

export const DetachedFn = () => {

	const newState = {
		dataNavLayout: "vertical",
		dataVerticalStyle: "detached",
		toggled: "detached-close",
		dataNavStyle: "",
	}
	setState(newState);
	localStorage.setItem('udonverticalstyles', 'detached');
	const MainContent = switcherSelector('.main-content');
	const appSidebar = switcherSelector('.app-sidebar');

	appSidebar?.addEventListener("click", () => {
		DetachedOpenFn();
	});
	MainContent?.addEventListener("click", () => {
		DetachedCloseFn();
	});
}

export const DoubletFn = () => {
	const newState = {
		dataNavLayout: "vertical",
		dataVerticalStyle: "doublemenu",
		toggled: "double-menu-open",
		dataNavStyle: "",
	}
	setState(newState);
	localStorage.setItem('udonverticalstyles', 'doublemenu')
	localStorage.removeItem('udonnavstyles')
	setTimeout(() => {
		if (!switcherSelector('.main-menu .slide.active ul')) {

			const newState = {
				toggled: 'double-menu-close'
			}
			setState(newState);

		}
	}, 100);

	// closeMenu1();
};

export const setPageStyle = (style: 'regular' | 'classic' | 'modern') => {
	const newState = {
		dataPageStyle: style
	};

	setState(newState);
	localStorage.setItem(`udon${style}`, style.charAt(0).toUpperCase() + style.slice(1));
	const styles = ['regular', 'classic', 'modern'];
	styles.forEach(item => {
		if (item !== style) {
			localStorage.removeItem(`udon${item}`);
		}
	});
};

export const setLayout = (layout: 'fullwidth' | 'boxed') => {
	const newState = {
		dataWidth: layout
	};

	setState(newState);

	localStorage.setItem(`udon${layout}`, layout.charAt(0).toUpperCase() + layout.slice(1));

	const layouts = ['fullwidth', 'boxed'];
	layouts.forEach(item => {
		if (item !== layout) {
			localStorage.removeItem(`udon${item}`);
		}
	});
};



export const setMenuPosition = (position: 'fixed' | 'scrollable') => {
	const newState = {
		dataMenuPosition: position
	};
	setState(newState);
	localStorage.setItem(`udonmenu${position}`, `Menu${position.charAt(0).toUpperCase() + position.slice(1)}`);
	const otherPosition = position === 'fixed' ? 'scrollable' : 'fixed';
	localStorage.removeItem(`udonmenu${otherPosition}`);
};

export const setHeaderPosition = (position: 'fixed' | 'scrollable') => {
	const newState = {
		dataHeaderPosition: position
	};
	setState(newState);
	localStorage.setItem(`udonheader${position}`, `Header${position.charAt(0).toUpperCase() + position.slice(1)}`);
	const otherPosition = position === 'fixed' ? 'scrollable' : 'fixed';
	localStorage.removeItem(`udonheader${otherPosition}`);
};

export const setMenuStyle = (style: string) => {

	localStorage.setItem('udonmenu', style);

	const currentColor = localStorage.getItem('udonmenu') || style
	const newState = {
		dataMenuStyles: currentColor
	};
	setState(newState);
	localStorage.setItem('udonmenu', style);
};

export const toggleTheme = () => {
	const currentTheme = getState();
	const newState = {
		dataThemeMode: currentTheme.dataThemeMode === 'dark' ? 'light' : 'dark',
		dataHeaderStyles: currentTheme.dataThemeMode === 'dark' ? 'light' : 'dark',
		dataMenuStyles: currentTheme.dataThemeMode === 'dark' ? 'dark' : 'dark',
	}
	setState(newState)
	if (newState.dataThemeMode != 'dark') {
		const newState = {
			bodyBg: '',
			lightRgb: '',
			bodyBg2: '',
			inputBorder: '',
			formControlBg: '',
			gray: '',
		}
		setState(newState)
		localStorage.setItem("udonlightTheme", "light");
		localStorage.removeItem("udondarkTheme");
		localStorage.removeItem("udonmenu");
		localStorage.removeItem("udonheader");
		localStorage.removeItem("bodyBg");
		localStorage.removeItem("bodyBg2");
		localStorage.removeItem("bgImg");
	}
	else {
		localStorage.setItem("udondarkTheme", "dark");
		localStorage.removeItem("udonlightTheme");
		localStorage.removeItem("udonmenu");
		localStorage.removeItem("udonheader");
		localStorage.removeItem("bodyBg");
		localStorage.removeItem("bodyBg2");
		localStorage.removeItem("inputBorder");
		localStorage.removeItem("lightRgb");
		localStorage.removeItem("formControlBg");
		localStorage.removeItem("gray");
	}
}

export const setHeaderStyle = (style: 'light' | 'dark' | 'color' | 'gradient' | 'transparent') => {
	const newState = {
		dataHeaderStyles: style
	};

	setState(newState);
	localStorage.setItem('udonheader', style);
};

export const setPrimaryColor = (rgb: string) => {
	const newState = {
		colorPrimaryRgb: rgb
	};

	setState(newState);
	localStorage.setItem('primaryRGB', rgb);
};

export const updateBackgroundColor = (bgColor1: string, bgColor2: string, clicked: string | boolean) => {
	const newState = {
		bodyBg: bgColor1,
		bodyBg2: bgColor2,
		inputBorder: 'rgba(255,255,255,0.1)',
		lightRgb: bgColor2,
		formControlBg: `rgb(${bgColor2})`,
		dataThemeMode: 'dark',
		dataMenuStyles: 'dark',
		dataHeaderStyles: 'dark',
		gray: 'rgba(255,255,255,0.1)',
	};

	setState(newState);
	localStorage.setItem('bodyBg', bgColor1);
	localStorage.setItem('bodyBg2', bgColor2);
	localStorage.setItem('lightRgb', bgColor2);
	localStorage.setItem('formControlBg', `rgb(${bgColor2})`);
	localStorage.setItem('inputBorder', `rgba(255,255,255,0.1)`);
	localStorage.setItem('gray', `rgba(255,255,255,0.1)`);
	localStorage.removeItem("udonlightTheme");
	localStorage.removeItem("udondarkTheme");

	if (clicked === 'clicked') {
		localStorage.removeItem('udonheader');
		localStorage.removeItem('udonmenu');
	}

};

// color pickers 
const ColorPicker = (props: JSX.IntrinsicAttributes & ClassAttributes<HTMLInputElement> & InputHTMLAttributes<HTMLInputElement>) => {
	return (
		<div className='color-picker-input'>
			<input type="color" {...props} />
		</div>
	)
}

const hexToRgb = (hex: string) => {
	var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
	return result ? {
		r: parseInt(result[1], 16),
		g: parseInt(result[2], 16),
		b: parseInt(result[3], 16),
	} : null
}

export const ThemePrimaryColor = ({ ariaLabel = 'Theme primary color' }: { ariaLabel?: string }) => {
	const [color, updateColor] = useState("#FFFFFF");
	const [rgb, _setRgb] = useState<{ colorPrimaryRgb: string }>({ colorPrimaryRgb: "" });

	const handleInput = (e: { target: { value: number; }; }) => {
		const color = e.target.value;
		let { r, g, b }: number = hexToRgb(color);

		if (color !== updateColor) {
			updateColor(color);
		}

		if (rgb.colorPrimaryRgb !== `${r}, ${g}, ${b}`) {
			const newState = {
				colorPrimaryRgb: `${r}, ${g}, ${b}`,
			};
			setState(newState);
			localStorage.setItem("dynamiccolor", `${r}, ${g}, ${b}`);
		}
	};

	return (
		<div className='Themeprimarycolor theme-container-primary pickr-container-primary'>
			<ColorPicker aria-label={ariaLabel} onChange={handleInput} value={color} />
		</div>
	);
};
interface Rgb {
	r: number;
	g: number;
	b: number;
}
// color picker for background colors 
export const ThemeBackgroundColor = ({ ariaLabel = 'Theme background color' }: { ariaLabel?: string }) => {
	const [state, updateState] = useState('#FFFFFF');

	const handleInput = (e: React.ChangeEvent<HTMLInputElement>) => {
		let { r, g, b }: Rgb = hexToRgb(e.target.value);
		updateState(e.target.value);
		const newState = {
			bodyBg: `${r + 14}, ${g + 14}, ${b + 14}`,
			bodyBg2: `${r}, ${g}, ${b}`,
			inputBorder: "rgba(255,255,255,0.1)",
			lightRgb: `${r + 5}, ${g + 5}, ${b + 5}`,
			formControlBg: `rgb(${r}, ${g}, ${b})`,
			dataThemeMode: "dark",
			dataHeaderStyles: "dark",
			dataMenuStyles: "dark",
			gray: `rgb(${r}, ${g}, ${b})`
		}
		setState(newState);

		localStorage.setItem("bodyBg", `${r}, ${g}, ${b}`);
		localStorage.setItem("bodyBg2", `${r + 14}, ${g + 14}, ${b + 14}`);
		localStorage.setItem("lightRgb", `${r + 5}, ${g + 5}, ${b + 5}`);
		localStorage.setItem("formControlBg", `rgb(${r}, ${g}, ${b})`);
		localStorage.removeItem("udonmenu");
		localStorage.removeItem("udonheader");
		localStorage.removeItem("udonlightTheme");
		localStorage.removeItem("udondarkTheme");
	}

	return (
		<div className="Themebackgroundcolor">
			<ColorPicker aria-label={ariaLabel} onChange={handleInput} value={state} />
		</div>
	)

}

export const setBgImage = (bgImageNumber: number) => {
	const bgImgKey = `bgimg${bgImageNumber}`;

	const newState = {
		bgImg: bgImgKey
	};

	setState(newState);

	for (let i = 1; i <= 5; i++) {
		if (i === bgImageNumber) {
			localStorage.setItem(`bgimage${i}`, bgImgKey);
		} else {
			localStorage.removeItem(`bgimage${i}`);
		}
	}
};

export const Reset = () => {
	const newState = {
		lang: "en",
		dir: "ltr",
		dataThemeMode: "light",
		dataMenuStyles: "light",
		dataNavLayout: "vertical",
		dataHeaderStyles: "light",
		dataVerticalStyle: "overlay",
		toggled: "",
		dataNavStyle: "",
		horStyle: "",
		dataPageStyle: "regular",
		dataWidth: "fullwidth",
		dataMenuPosition: "fixed",
		dataHeaderPosition: "fixed",
		iconOverlay: "",
		colorPrimaryRgb: "",
		bodyBg: "",
		bodyBg2: "",
		inputBorder: "",
		lightRgb: "",
		formControlBg: "",
		gray: "",
		bgImg: "",
		loader: "disable",
		iconText: "",
		body: {
			class: ""
		}
	};

	setState(newState);
	localStorage.clear()

	const icon = switcherDoucmentIdSelector('switcher-default-menu') as HTMLInputElement;
	if (icon) {
		icon.checked = true;
	}
};

export const Reset1 = () => {
	const newState = {
		lang: "en",
		dir: "ltr",
		dataThemeMode: "light",
		dataMenuStyles: "",
		dataNavLayout: "horizontal",
		toggled: "",
		dataNavStyle: "menu-click",
		horStyle: "",
		dataMenuPosition: "fixed",
		iconOverlay: "",
		colorPrimaryRgb: "",
		bodyBg: "",
		bodyBg2: "",
		inputBorder: "",
		lightRgb: "",
		formControlBg: "",
		gray: "",
		bgImg: "",
		loader: "disable",
		iconText: "",
		body: {
			class: ""
		}
	};

	setState(newState);
	localStorage.clear()

	const icon = switcherDoucmentIdSelector("switcher-default-menu") as HTMLInputElement;
	if (icon) {
		icon.checked = true;
	}
};

export const LocalStorageBackup = (setpageloading: (arg0: boolean) => void) => {
	updateTheme(getPreferredThemeMode(), true);
	(localStorage.udonrtl) ? setDirection('rtl') : '';
	(localStorage.udonregular) ? setPageStyle('regular') : '';
	(localStorage.udonclassic) ? setPageStyle('classic') : '';
	(localStorage.udonmodern) ? setPageStyle('modern') : '';
	(localStorage.udonfullwidth) ? setLayout('fullwidth') : '';
	(localStorage.udonboxed) ? setLayout('boxed') : '';
	(localStorage.udonmenufixed) ? setMenuPosition('fixed') : '';
	(localStorage.udonmenuscrollable) ? setMenuPosition('scrollable') : '';
	(localStorage.udonheaderfixed) ? setHeaderPosition('fixed') : '';
	(localStorage.udonheaderscrollable) ? setHeaderPosition('scrollable') : '';
	(localStorage.bgimage1) ? setBgImage(1) : '';
	(localStorage.bgimage2) ? setBgImage(2) : '';
	(localStorage.bgimage3) ? setBgImage(3) : '';
	(localStorage.bgimage4) ? setBgImage(4) : '';
	(localStorage.bgimage5) ? setBgImage(5) : '';
	(localStorage.udonnavstyles === "menu-click") ? updateNavStyle('menu-click', 'menu-click-closed') : '';
	(localStorage.udonnavstyles === "menu-hover") ? updateNavStyle('menu-hover', 'menu-hover-closed') : '';
	(localStorage.udonnavstyles === "icon-click") ? updateNavStyle('icon-click', 'icon-click-closed') : '';
	(localStorage.udonnavstyles === "icon-hover") ? updateNavStyle('icon-hover', 'icon-hover-closed') : '';
	(localStorage.udonLayout == 'horizontal') && updateLayout('horizontal');

	switch (localStorage.udonmenu) {
		case 'light':
			setMenuStyle('light');
			break;
		case 'dark':
			localStorage.getItem('udonmenu') ? localStorage.getItem('udonmenu') : setMenuStyle('dark');
			break;
		case 'color':
			setMenuStyle('color');
			break;
		case 'gradient':
			setMenuStyle('gradient');
			break;
		case 'transparent':
			setMenuStyle('transparent');
			break;
		default:
			break;
	}

	switch (localStorage.udonheader) {
		case 'light':
			setHeaderStyle('light');
			break;
		case 'dark':
			setHeaderStyle('dark');
			break;
		case 'color':
			setHeaderStyle('color');
			break;
		case 'gradient':
			setHeaderStyle('gradient');
			break;
		case 'transparent':
			setHeaderStyle('transparent');
			break;
		default:
			break;
	}

	switch (localStorage.primaryRGB) {
		case '171, 125, 241':
			setPrimaryColor('171, 125, 241');
			break;
		case '69, 184, 224':
			setPrimaryColor('69, 184, 224');
			break;
		case '231, 105, 182':
			setPrimaryColor('231, 105, 182');
			break;
		case '26, 139, 114':
			setPrimaryColor('26, 139, 114');
			break;
		case '10, 106, 169':
			setPrimaryColor('10, 106, 169');
			break;
		default:
			break;
	}

	switch (localStorage.bodyBg) {
		case '70, 40, 115':
			updateBackgroundColor('70, 40, 115', '84, 54, 129', true);
			break;
		case '32, 87, 105':
			updateBackgroundColor('32, 87, 105', '46, 101, 119', true);
			break;
		case '105, 40, 83':
			updateBackgroundColor('105, 40, 83', '119, 54, 97', true);
			break;
		case '0, 56, 51':
			updateBackgroundColor('0, 56, 51', '14, 70, 65', true);
			break;
		case '5, 53, 100':
			updateBackgroundColor('5, 53, 100', '19, 67, 114', true);
			break;
		default:
			break;
	}


	if (localStorage.dynamiccolor) {
		const dynamiccolor = localStorage.getItem('dynamiccolor')
		const newState = {
			colorPrimaryRgb: dynamiccolor,
		}
		setState(newState);
	}
	if (localStorage.bodyBg) {

		const newState = {
			bodyBg: localStorage.bodyBg,
			bodyBg2: localStorage.bodyBg2,
			dataThemeMode: "dark",
			dataHeaderStyles: localStorage.udonheader ? localStorage.udonheader : localStorage.udondarkTheme ? "dark" : "dark",
			lightRgb: localStorage.lightRgb,
			formControlBg: localStorage.formControlBg,
			inputBorder: localStorage.inputBorder,
			gray: localStorage.gray,
			dataMenuStyles: localStorage.udonmenu ? localStorage.udonmenu : localStorage.udondarkTheme ? "dark" : "dark"
		}
		setState(newState)
		console.log(newState)

	}

	if (localStorage.udonverticalstyles) {
		let verticalstyles = localStorage.getItem('udonverticalstyles');

		switch (verticalstyles) {
			case 'default':
				let defaultId = switcherDoucmentIdSelector('switcher-default-menu') as HTMLInputElement;
				if (defaultId) {
					defaultId.checked = true;
				}
				DefaultMenu();
				break;

			case 'closed':
				let closedId = switcherDoucmentIdSelector('switcher-icontext-menu') as HTMLInputElement;
				if (closedId) {
					closedId.checked = true;
				};
				ClosedMenu();
				break;

			case 'icontext':
				let icontextId = switcherDoucmentIdSelector('switcher-icontext-menu') as HTMLInputElement;
				if (icontextId) {
					icontextId.checked = true;
				};
				IconText();
				break;

			case 'overlay':
				let overlayId = switcherDoucmentIdSelector('switcher-detached') as HTMLInputElement;
				if (overlayId) {
					overlayId.checked = true;
				};
				iconOverlayFn();
				break;

			case 'detached':
				let detachedId = switcherDoucmentIdSelector('switcher-detached') as HTMLInputElement;
				if (detachedId) {
					detachedId.checked = true;
				};
				DetachedFn();
				break;

			case 'doublemenu':
				let doubleId = switcherDoucmentIdSelector('switcher-double-menu') as HTMLInputElement;
				if (doubleId) {
					doubleId.checked = true;
				};
				DoubletFn();
				break;

			default:
				let defaultbutton = switcherDoucmentIdSelector('switcher-default-menu') as HTMLInputElement;
				if (defaultbutton) {
					defaultbutton.checked = true;
				}
				break;
		}

	}

	setpageloading(true)
};

